/**
 * A failure inside `fetch` itself: no response, no status, nothing known about the request except
 * that it did not happen. The message is the only signal, and it differs by platform - browsers
 * reject with "Failed to fetch", the whatwg-fetch polyfill React Native runs on rejects with
 * "Network request failed" - so checking for one of them silently misses the other's devices.
 */
const NETWORK_ERROR_MESSAGES = [
    'Failed to fetch', // browser fetch
    'TypeError: Failed to fetch', // ...as re-wrapped by callers that stringify the error first
    'Network request failed', // whatwg-fetch, i.e. React Native
    'net::ERR_NAME_NOT_RESOLVED'
];

/**
 * @param {{message?:string}} err
 * @returns {boolean} true when `fetch` failed to reach the server at all
 */
export default function isNetworkError(err) {
    return NETWORK_ERROR_MESSAGES.includes(err?.message);
}
